// Maps the raw `ff_segmentedRecording` localStorage value to whether the
// segmented/streaming web recording path is enabled.
//
// Default ON: any value EXCEPT the literal string "0" enables it (a missing key
// arrives here as null). Setting it to "0" is the kill-switch that forces the
// proven single-blob path per-browser with no redeploy. Remove this switch once
// the segmented path is proven in production.
export function isSegmentedRecordingEnabled(rawValue) {
  return rawValue !== "0";
}
